module.exports = __webpack_public_path__ + "img/logo-footer.426d2a3f.svg";